module.exports = __webpack_public_path__ + "static/media/city.529b14e1.jpg";